import React, { memo } from 'react';
import PropTypes from 'prop-types';

const TideSchedule = ({ processedTides, currentWaterLevel }) => {
  return (
    <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700 animate-on-scroll card-hover hover-lift">
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-semibold text-lg dark:text-gray-100">🌊 Tide Schedule</h3>
        {currentWaterLevel !== null && currentWaterLevel !== undefined && (
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Current: <span className="font-medium dark:text-gray-200">{currentWaterLevel.toFixed(1)} ft</span>
          </p>
        )}
      </div>
      {processedTides.length > 0 ? (
        <div className="space-y-3">
          {processedTides.map((tide, idx) => {
            
            return (
              <div key={idx} className="flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-lg">
                <div className="flex items-center gap-3">
                  <span className="text-2xl">{tide.isHigh ? '⬆️' : '⬇️'}</span>
                  <div>
                    <p className="font-semibold dark:text-gray-100">{tide.isHigh ? 'High Tide' : 'Low Tide'}</p>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {tide.tideTime.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-bold text-lg dark:text-gray-100">
                    {tide.tideTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{tide.v?.toFixed(1) || '--'} ft</p>
                  {tide.timeDiff && (
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      Next in {tide.timeDiff.toFixed(1)} hrs
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-600 dark:text-gray-400 text-center py-4">Tide data unavailable</p>
      )}
    </div>
  );
};

TideSchedule.propTypes = {
  processedTides: PropTypes.arrayOf(PropTypes.shape({
    tideTime: PropTypes.instanceOf(Date),
    isHigh: PropTypes.bool,
    v: PropTypes.number,
    timeDiff: PropTypes.number
  })),
  currentWaterLevel: PropTypes.number
};

export default memo(TideSchedule);